<template>
  <v-card style="position: relative">
    <v-card-title class="primary"
      ><h4 style="color: white">{{ $t("form_live") }}</h4>
      <v-icon @click="onClose" color="white" style="margin-left: auto">{{
        mdiClose
      }}</v-icon>
    </v-card-title>
    <v-card-text style="margin-top: 22px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          :rules="nameRules"
          required
          v-model="dataRequest.name"
          label="Your name"
        >
        </v-text-field>
        <v-text-field
          :rules="emailRules"
          required
          v-model="dataRequest.email"
          label="Your email"
        >
        </v-text-field>
        <v-textarea
          :rules="noteRules"
          required
          v-model="dataRequest.note"
          label="Note"
        >
        </v-textarea>
      </v-form>

      <span v-if="this.statusSubmit === -1" style="color: #c82333">
        Submit data error
      </span>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        width="100px"
        color="primary"
        style="text-transform: none"
        @click="onSubmit"
        :loading="this.statusSubmit === 0"
        :disabled="!this.valid"
        >{{ $t("submit") }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiClose } from "@mdi/js";
import { call, sync } from "vuex-pathify";

export default {
  name: "FormRequestLive",
  data() {
    return {
      dataRequest: {
        name: "",
        email: "",
        note: "",
      },
      noteRules: [
        (v) => !!v || "Note is required",
        (v) =>
          (v && v.length <= 500) || "Note must be less than 500 characters",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      mdiClose: mdiClose,
    };
  },
  methods: {
    submitRequestLive: call("liveStream/submitRequestLive"),
    onClose() {
      this.dataRequest = {};
      this.$refs.form.reset();
      this.statusSubmit = 1;
      this.$emit("close");
    },
    async onSubmit() {
      await this.$refs.form.validate();
      if (this.valid) {
        await this.submitRequestLive(this.dataRequest);
        if (this.statusSubmit === 1) {
          this.onClose();
        }
      }
    },
  },
  computed: {
    statusSubmit: sync("liveStream/statusSubmit"),
  },
};
</script>

<style scoped></style>
